
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class BillingDocumentLineModel extends Model<BillingDocumentLineModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'creditLine', type: 'boolean' },
		{ name: 'description', type: 'string' },
		{ name: 'quantity', type: 'number' },
		{ name: 'unitPrice', type: 'number' },
		{ name: 'type', type: 'LineType' },
		{ name: 'lineNumber', type: 'number' },
		{ name: 'metaData', type: 'string' },
		{ name: 'totalNetAmount', type: 'number' },
		{ name: 'businessCentralData', type: 'BusinessCentralDataModel', isHidden: true, isObject: true, new: () => { return new BusinessCentralDataModel }, properties: () => { return BusinessCentralDataModel.classProperties } }
	];
	[key: string]: any;
	
	public creditLine: boolean;
	public description?: string;
	public quantity?: number;
	public unitPrice?: number;
	public type: LineType;
	public lineNumber?: number;
	public metaData?: string;
	public totalNetAmount?: number;
	public businessCentralData?: BusinessCentralDataModel;
    
	constructor(){
		super();
		this.creditLine = false;
		this.description = undefined;
		this.quantity = undefined;
		this.unitPrice = undefined;
		this.type = 0;
		this.lineNumber = undefined;
		this.metaData = undefined;
		this.totalNetAmount = undefined;
		this.businessCentralData = undefined;
		
	}
	getProperties(){
		return BillingDocumentLineModel.classProperties;
	}
}
export class BusinessCentralDataModel extends Model<BusinessCentralDataModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productDimension', type: 'string' },
		{ name: 'salesTypeDimension', type: 'string' },
		{ name: 'departmentDimension', type: 'string' },
		{ name: 'companyTypeDimension', type: 'string' },
		{ name: 'typeNumber', type: 'string' },
		{ name: 'type', type: 'number' }
	];
	[key: string]: any;
	
	public productDimension: string;
	public salesTypeDimension: string;
	public departmentDimension: string;
	public companyTypeDimension: string;
	public typeNumber: string;
	public type: number;
    
	constructor(){
		super();
		this.productDimension = '';
		this.salesTypeDimension = '';
		this.departmentDimension = '';
		this.companyTypeDimension = '';
		this.typeNumber = '';
		this.type = 0;
		
	}
	getProperties(){
		return BusinessCentralDataModel.classProperties;
	}
}

export enum LineType{
	InvoiceProduct = 0,
	Text = 1,
	HandlingFee = 2,
	ClickBudget = 3
}
export namespace LineType {
	export function getKeys(): Map<LineType, string> {
		return new Map([[0, 'InvoiceProduct'], [1, 'Text'], [2, 'HandlingFee'], [3, 'ClickBudget']]);
	}
}
